import {createSlice} from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const faultAdapter = getAdapter({idFieldName: 'value'} );

const faultSlice = createSlice({
    name: 'fault',
    initialState: faultAdapter.getInitialState(),
    reducers: {
        setFault: (state, {payload: {fault}}) => {
            faultAdapter.setAll(state, fault);
        }
    }
});

const selectors = faultAdapter.getSelectors(({fault}) => fault);

export const getFault = state =>  selectors.selectAll(state);

export const {setFault } = faultSlice.actions;
export default faultSlice.reducer;